import { IAssortmentItem } from '../../../features/assortment/models/data/IAssortmentItem'

// this ackward mapper was created to avoid uneccessary fields like Created, CreatedBy, Modified, ModifiedBy
export const mapAssortmentCard = (apiCard: IAssortmentItem): IAssortmentItem => {
  return {
    Comments: apiCard.Comments,
    Configs: apiCard.Configs,
    Configurations: apiCard.Configurations,
    Focus: apiCard.Focus,
    EntryId: apiCard.EntryId,
    AssortmentGroupId: apiCard.AssortmentGroupId,
    ProductCodeName: apiCard.ProductCodeName,
    Status: apiCard.Status,
    StatusText: apiCard.StatusText,
    Suppliers: apiCard.Suppliers,
    Units: apiCard.Units,
    SortOrder: apiCard.SortOrder,
  }
}
